var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkContent)?_c('div',{staticClass:"p-kao",attrs:{"id":"p-kao"}},[_c('div',{staticClass:"h11 position-relative",attrs:{"id":"p-kao-1"}}),_c('div',{staticClass:"b-title d-flex align-items-center"},[_vm._v(" 考核信息 ")]),_c('div',{staticClass:"bg-white p-body px-3 mb-3"},[_vm._v(_vm._s(_vm.checkContent))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }